module.exports = __webpack_public_path__ + "static/media/twitch-tv-preview.7571b0d4.jpg";